import React from 'react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';

const AboutPage: React.FC = () => {
  return (
    <div className="landing-page">
      <SiteNav currentPage="about" />

      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">About ElevenUp</h1>
          <p className="page-hero-subtitle">A tutor at the price of a few practice exams.</p>
        </div>
      </section>

      {/* Our Story */}
      <section className="about-story-section">
        <div className="container">
          <div className="story-card">
            <h2>Our Story</h2>
            <p>
              ElevenUp started the way most good things do &mdash; out of necessity. One of us is a mum whose child was preparing for the 11+ exam. The other had spent five years in the classroom and knew how students actually learn. Together, we built a tool for one child. That child got into a brilliant school.
            </p>
            <p>
              We looked at each other and thought: why keep this to ourselves?
            </p>
            <p>
              So we didn't. ElevenUp is the prep tool we wished existed &mdash; smart enough to adapt, patient enough to explain every mistake, and affordable enough that any family can use it. Not a replacement for a great teacher, but a tireless study partner that never loses its cool.
            </p>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <section className="about-team-section">
        <div className="container">
          <h2 className="section-title">Who We Are</h2>
          <p className="about-team-intro">
            We're a team of two. No venture capital, no big office, no corporate jargon. Just two people who genuinely care about giving every child a fair shot.
          </p>
          <div className="team-grid">
            <div className="team-card">
              <div className="team-card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4FCCC6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
              <h3>The Builder</h3>
              <p>
                Five years as a classroom teacher. A background in psychology and human factors. A commercial pilot's licence (yes, really). Now channelling all of that into building AI tools that make a genuine difference for kids. Obsessed with getting the details right &mdash; because when a 10-year-old gets a wrong answer, the explanation needs to actually make sense.
              </p>
            </div>
            <div className="team-card">
              <div className="team-card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4FCCC6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
              </div>
              <h3>Rain</h3>
              <p>
                Mum, entrepreneur, and the reason ElevenUp exists. After guiding her own child through the 11+ in 2025, she knew firsthand how stressful &mdash; and how expensive &mdash; exam prep can be. She's built businesses before (including a bar in China, because why not?) and now she's on a mission to make quality 11+ preparation accessible to every family. She handles outreach, partnerships, and making sure we never forget who we're building this for.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Believe */}
      <section className="about-values-section">
        <div className="container">
          <h2 className="section-title light">What We Believe</h2>
          <div className="values-list">
            <div className="value-feature">
              <div>
                <h4>Every child deserves a fair shot.</h4>
                <p>Expensive tutoring shouldn't be the thing that decides a child's future.</p>
              </div>
            </div>
            <div className="value-feature">
              <div>
                <h4>Understanding beats memorising.</h4>
                <p>Our AI tutor explains the why, not just the what. That's how real learning sticks.</p>
              </div>
            </div>
            <div className="value-feature">
              <div>
                <h4>Safety is non-negotiable.</h4>
                <p>Parental consent first. No ads, no tracking, no data sharing. Full stop.</p>
              </div>
            </div>
            <div className="value-feature">
              <div>
                <h4>Keep it real.</h4>
                <p>We're two people who care about this. You'll always get a real person when you reach out.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="section-title" style={{ color: 'white' }}>Ready to try it?</h2>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.8)' }}>
            Join early access and give your child a head start &mdash; for free.
          </p>
          <a href="/#waitlist" className="btn-primary-light">
            Get Early Access
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default AboutPage;
